module.exports = __webpack_public_path__ + "static/media/chat04.9e7c730a.gif";